import { SVGUniqueID } from './svg-unique-id';
import type { IconProps } from './types';
const Icon = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    width={props.size || 24}
    height={props.size || 24}
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      d="M21.7153 9.01283L18.3606 7L14.3349 16.3932L6.28357 12.3675L3.5998 15.7223"
      stroke="#0035A4"
      strokeWidth={1.29974}
    />
    <ellipse
      cx={3.16148}
      cy={16.2125}
      rx={1.16148}
      ry={1.16148}
      fill="#0035A4"
    />
    <ellipse
      cx={14.3353}
      cy={16.0868}
      rx={1.16148}
      ry={1.16148}
      fill="#0035A4"
    />
    <ellipse
      cx={21.277}
      cy={8.57396}
      rx={1.16148}
      ry={1.16148}
      fill="#0035A4"
    />
  </svg>
);
const SvgLineColored = (props: IconProps) => (
  <SVGUniqueID>{Icon(props)}</SVGUniqueID>
);
export default SvgLineColored;
